"use strict";

var _StandaloneMsgHandler = require("../../eventbus/StandaloneMsgHandler");
var _usersmanagement = require("../../functions/usersmanagement");
(0, _StandaloneMsgHandler.registerStandaloneAPIHandler)("/aether/auth/kc/umd", function (method, data) {
  if (method === "get") {
    return {
      response: (0, _StandaloneMsgHandler.createUIReply)((0, _usersmanagement.getUserManagementData)())
    };
  }
});
(0, _StandaloneMsgHandler.registerStandaloneAPIHandler)("/aether/auth/kc/uf", function (method, data) {
  if (method === "get") {
    return {
      response: (0, _StandaloneMsgHandler.createUIReply)((0, _usersmanagement.getUserExternAuth)())
    };
  }
});
(0, _StandaloneMsgHandler.registerStandaloneAPIHandler)("/aether/auth/kc/event/login", function (method, data) {
  if (method === "get") {
    return {
      response: (0, _StandaloneMsgHandler.createUIReply)((0, _usersmanagement.getLoginEvents)())
    };
  }
});
(0, _StandaloneMsgHandler.registerStandaloneAPIHandler)("/aether/auth/kc/event/admin", function (method, data) {
  if (method === "get") {
    return {
      response: (0, _StandaloneMsgHandler.createUIReply)((0, _usersmanagement.getAdminEvents)())
    };
  }
});
(0, _StandaloneMsgHandler.registerStandaloneAPIHandler)("/aether/open/kc/user/authorizesetup", function (method, data) {
  if (method === "post") {
    return {
      response: (0, _StandaloneMsgHandler.createUIReply)((0, _usersmanagement.getAuthSuccessMsg)())
    };
  }
});
(0, _StandaloneMsgHandler.registerStandaloneAPIHandler)("/init/setup/open/status", function (method, data) {
  if (method === "get") {
    return {
      response: (0, _StandaloneMsgHandler.createUIReply)((0, _usersmanagement.getOpenStatus)())
    };
  }
});
(0, _StandaloneMsgHandler.registerStandaloneAPIHandler)("/init/setup/auth/status", function (method, data) {
  if (method === "get") {
    return {
      response: (0, _StandaloneMsgHandler.createUIReply)((0, _usersmanagement.getAuthStatus)())
    };
  }
});
(0, _StandaloneMsgHandler.registerStandaloneAPIHandler)("/init/setup/auth/cors/status", function (method, data) {
  if (method === "get") {
    return {
      response: (0, _StandaloneMsgHandler.createUIReply)((0, _usersmanagement.getCorsStatus)())
    };
  }
});
(0, _StandaloneMsgHandler.registerStandaloneAPIHandler)("/init/setup/auth/cors", function (method, data) {
  if (method === "post") {
    return {
      response: (0, _StandaloneMsgHandler.createUIReply)((0, _usersmanagement.setCorsStatus)(data))
    };
  }
});
(0, _StandaloneMsgHandler.registerStandaloneAPIHandler)("/aether/auth/kc/user/add", function (method, data) {
  if (method === "post") {
    return {
      response: (0, _StandaloneMsgHandler.createUIReply)((0, _usersmanagement.addUser)(data))
    };
  }
});
(0, _StandaloneMsgHandler.registerStandaloneAPIHandler)("/aether/auth/kc/user/update", function (method, data) {
  if (method === "post") {
    return {
      response: (0, _StandaloneMsgHandler.createUIReply)((0, _usersmanagement.updateUser)(data))
    };
  }
});
(0, _StandaloneMsgHandler.registerStandaloneAPIHandler)("/aether/auth/kc/user/delete", function (method, data) {
  if (method === "post") {
    return {
      response: (0, _StandaloneMsgHandler.createUIReply)((0, _usersmanagement.deleteUser)(data))
    };
  }
});
(0, _StandaloneMsgHandler.registerStandaloneAPIHandler)("/aether/auth/kc/user/enable", function (method, data) {
  if (method === "post") {
    return {
      response: (0, _StandaloneMsgHandler.createUIReply)((0, _usersmanagement.enableOrDisableUser)(data, true))
    };
  }
});
(0, _StandaloneMsgHandler.registerStandaloneAPIHandler)("/aether/auth/kc/user/disable", function (method, data) {
  if (method === "post") {
    return {
      response: (0, _StandaloneMsgHandler.createUIReply)((0, _usersmanagement.enableOrDisableUser)(data, false))
    };
  }
});
(0, _StandaloneMsgHandler.registerStandaloneAPIHandler)("/aether/auth/kc/user/resetpassword", function (method, data) {
  if (method === "post") {
    return {
      response: (0, _StandaloneMsgHandler.createUIReply)((0, _usersmanagement.resetPassword)(data))
    };
  }
});
(0, _StandaloneMsgHandler.registerStandaloneAPIHandler)("/aether/auth/kc/group/add", function (method, data) {
  if (method === "post") {
    return {
      response: (0, _StandaloneMsgHandler.createUIReply)((0, _usersmanagement.addGroup)(data))
    };
  }
});
(0, _StandaloneMsgHandler.registerStandaloneAPIHandler)("/aether/auth/kc/group/copy", function (method, data) {
  if (method === "post") {
    return {
      response: (0, _StandaloneMsgHandler.createUIReply)((0, _usersmanagement.copyGroup)(data))
    };
  }
});
(0, _StandaloneMsgHandler.registerStandaloneAPIHandler)("/aether/auth/kc/group/delete", function (method, data) {
  if (method === "post") {
    return {
      response: (0, _StandaloneMsgHandler.createUIReply)((0, _usersmanagement.deletegroup)(data))
    };
  }
});
(0, _StandaloneMsgHandler.registerStandaloneAPIHandler)("/aether/auth/kc/group/update", function (method, data) {
  if (method === "post") {
    return {
      response: (0, _StandaloneMsgHandler.createUIReply)((0, _usersmanagement.updateGroup)(data))
    };
  }
});
(0, _StandaloneMsgHandler.registerStandaloneAPIHandler)("/aether/auth/kc/user/assignusers", function (method, data) {
  if (method === "post") {
    return {
      response: (0, _StandaloneMsgHandler.createUIReply)((0, _usersmanagement.assignUsersToGroup)(data))
    };
  }
});
(0, _StandaloneMsgHandler.registerStandaloneAPIHandler)("/aether/auth/kc/user/assigngroups", function (method, data) {
  if (method === "post") {
    return {
      response: (0, _StandaloneMsgHandler.createUIReply)((0, _usersmanagement.assignGroupToUser)(data))
    };
  }
});
(0, _StandaloneMsgHandler.registerStandaloneAPIHandler)("/init/setup/auth/setup", function (method, data) {
  if (method === "post") {
    return {
      response: (0, _StandaloneMsgHandler.createUIReply)("")
    };
  }
});